import { Text } from '@chakra-ui/react'

export const PurchasedLabel = () => {
  return (
    <Text color="label.accent" fontSize="sm" border="1px" borderColor="label.accent" borderRadius="3px" textAlign="center" w="4.5rem" p="2px">
      購入済み
    </Text>
  )
}
